import { createSelector } from 'reselect';
import orderBy from 'lodash/orderBy';
import { RootState } from 'store/types';

import { Consumer } from 'store/profile/types';
import { currentAccountConsumerSelector } from 'store/account/selectors';

import { $Keys } from 'utility-types';

const filterByConsumerId = <T extends Record<string, any>>(
  data: T[],
  consumer: Consumer,
  dataConsumerKey = 'consumerId',
  consumerKey: $Keys<Consumer> = 'consumerId'
) => {
  if (!consumer) {
    return data;
  }

  return data.filter(d => d[dataConsumerKey] === consumer[consumerKey]);
};

export const upcomingAppointmentsSelector = (state: RootState) =>
  state.booking.appointments.upcoming;

export const upcomingAppointmentsFetchingSelector = createSelector(
  upcomingAppointmentsSelector,
  upcoming => upcoming.isFetching
);

export const upcomingAppointmentsErrorSelector = createSelector(
  upcomingAppointmentsSelector,
  upcoming => upcoming.error
);

export const upcomingAppointmentsDataSelector = createSelector(
  upcomingAppointmentsSelector,
  upcoming => upcoming.data
);

export const upcomingAppointmentsRequestStateSelector = createSelector(
  upcomingAppointmentsSelector,
  upcoming => upcoming.requestState
);

export const upcomingAppointmentForConsumerSelector = createSelector(
  [upcomingAppointmentsDataSelector, currentAccountConsumerSelector],
  (appts, account) => orderBy(filterByConsumerId(appts, account), ['appointmentDate'], ['asc'])
);
